import {
  Component,
  EnvironmentInjector,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GetDataPath, IStatusPanelParams, StatusPanelDef } from 'ag-grid-community';
import { PaginationBarComponent } from '../pagination-bar/pagination-bar.component';
import { GridService } from '../service/grid.service';
import {
  CustomFacade,
  Helper,
  MyOrganizationFacade,
  ProjectsFacade,
  SharedFacade,
  delayedFunctionCall,
} from '@piqet-angular/data';
import {
  GridReadyEvent,
  SideBarDef,
  IServerSideDatasource,
  IServerSideGetRowsRequest,
  RowModelType,
  IViewportDatasource,
  IViewportDatasourceParams,
} from '@ag-grid-community/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { CustomModalService } from '../modal/custom-modal.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ProjectScenarioConfigDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-configuration/project-scenario-config-data-grid.service';

@Component({
  selector: 'piqet-angular-ag-grid',
  templateUrl: './ag-grid.component.html',
  styleUrls: ['./ag-grid.component.css'],
})
export class AgGridComponent implements OnInit, OnChanges, OnDestroy {
  @Input() columnDefs!: any;
  @Input() autoGroupColumnDef!: any;
  @Input() treeData = false;
  @Input() frameworkComponents!: any;
  @Input() gridData: any;
  @Input() class: any = '';
  @Input() pageNo: any;
  @Input() hidePagination: any;
  @Input() headerBtnName: any;
  @Input() hideSideBar = true;
  @Input() gridName = '';
  @Input() gridConfig: any = [];
  @Input() supressPagination = false;
  @Input() inlineEdit = false;
  @Input() isChekIniline = false;
  @Input() stepCountAg: any;
  @Input() stepTitleAg: any;
  @Input() stepTextAg: any;
  @Input() stepPositionAg: any;
  @Input() isAnimateRows = false;
  @Input() isServerSide = false;
  @Input() isCheckOrganization = false;
  @Input() totalCount = 0;
  public editType: 'fullRow' = 'fullRow';
  @Output() paginationChangeEvent = new EventEmitter<any>();
  @Output() sortChangeEvent = new EventEmitter<any>();
  @Output() editDataEvent = new EventEmitter<any>();
  @Output() inlineDataEditEvent = new EventEmitter<[any, any, string, string, any]>();
  @Output() guidedTourGridEvent = new EventEmitter<any>();
  @Output() guidedTourGridPrevEvent = new EventEmitter<any>();
  @Output() changeRowOrder = new EventEmitter<any>();

  columnDefsMain: any = [];
  detailRowHeight = 0;
  currentRoute: any;
  gridApi: any;
  @Input() context: any;
  isSingleClickEdit = false;
  pageSize = 10;

  isClientSide = true;
  public noRowsTemplate: any;
  public statusBar!: {
    statusPanels: StatusPanelDef[];
  };
  public sideBar!: SideBarDef | string | string[] | boolean | any;
  public rowData: any = [];
  public overlayNoRowsTemplate =
    '<span style="color: #a3a4a9; font-family: Neue Montreal; font-weight: 400;" class="border-0">No data available in table</span>';
  public params: any;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  quickFilterTimeout: any;
  getApiData: any;

  @Input() isInlineGrid = false;
  @Input() isEOLGrid = false;

  public groupDefaultExpanded = -1;
  public getDataPath: GetDataPath = (data: any) => {
    return data.filePath;
  };

  constructor(
    private gridService: GridService,
    public customFacade: CustomFacade,
    public sharedfacade: SharedFacade,
    private injector: EnvironmentInjector,
    private projectFacade: ProjectsFacade,
    private modal: CustomModalService,
    private projectsService: ProjectsService,
    private projectScenarioConfigDataGridService: ProjectScenarioConfigDataGridService,
    private myOrganizationFacade: MyOrganizationFacade
  ) {
    this.gridService.gridCellEdited$.subscribe((data: any) => {
      this.getApiData = data[0];
      this.onEditButtonClick(data[0]);
      this.isSingleClickEdit = data[1];
    });

    if (!this.hideSideBar) {
      this.sharedfacade.getGridConfigs();
    }
  }

  ngOnInit() {
    const isRowDrag = this.columnDefs?.some((item: any) => item?.rowDrag === true);
    if (isRowDrag) {
      this.hidePagination = isRowDrag;
    }
    this.initializeGrid();
  }

  async initializeGrid() {
    if (!this.hideSideBar) {
      setTimeout(() => {
        this.injector.runInContext(async () => {
          this.sharedfacade.setGridState({
            [this.gridName]: Helper.setGridConfigs(this.columnDefs, this.gridName),
          });
          await this.setColumnDef(this.gridName);
        });
      }, 200);
    }
    if (!this.hidePagination) {
      this.statusBar = {
        statusPanels: [
          {
            statusPanel: PaginationBarComponent,
            statusPanelParams: {
              checkPaginationStatus: !this.hidePagination,
              pageSize: this.pageSize,
              gridName: this.gridName,
              onPageSizeChanged: (newValue: any, currentPage: number | null) => {
                this.onPageSizeChanged(newValue, currentPage);
                this.gridApi?.deselectAll();
              },
              onPrevClicked: () => {
                //this.onPrevClicked();
                this.gridApi?.deselectAll();
              },
              onNextClicked: () => {
                // this.onNextClicked();
                this.gridApi?.deselectAll();
              },
              onPageNumberClicked: (pageNumber: any, gridName: any, pageSize: number) => {
                this.onPageNumberClicked(pageNumber, gridName, pageSize);
                this.gridApi?.deselectAll();
              },
              getGridApi: (params: IStatusPanelParams) => {
                this.gridApi = params.api;
              },
              getTotalRecords: () => {
                if (this.isServerSide) {
                  return this.totalCount;
                } else {
                  return this.pageSize == this.gridData?.length
                    ? this.gridData?.length
                    : this.gridApi?.getDisplayedRowCount();
                }
              },
              getTotalFilteredRecords: () => {
                if (this.isServerSide) {
                  return this?.totalCount;
                } else {
                  return this.pageSize == this.gridData?.length
                    ? this.gridData?.length
                    : this.gridApi?.getDisplayedRowCount();
                }
              },
            },
          },
        ],
      };
    }

    this.sideBar = this.hideSideBar
      ? false
      : {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'menu',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: true,
                suppressColumnSelectAll: true,
                suppressColumnExpandAll: true,
              },
            },

            {
              id: 'agGridSideBar',
              labelDefault: 'Grid options',
              labelKey: 'gridOptions',
              iconKey: 'grip',
              toolPanel: SidebarComponent,
            },
          ],
          //defaultToolPanel: 'columns',
        };
    await this.setSidebarProps();
    this.gridApi?.showLoadingOverlay();
  }

  getRowNodeId(data: any) {
    return data.index;
  }

  setColumnDef(gridName: any) {
    this.sharedfacade.gridState$.subscribe((data: any) => {
      if (Object.keys(data) == gridName) {
        this.columnDefs = data[gridName];
      } else {
        if (data[gridName]) {
          this.columnDefs.push(...data[gridName]);
        }
      }
    });
  }

  setSidebarProps() {
    this.sideBar?.toolPanels?.forEach((panel: any) => {
      if (panel.id === 'agGridSideBar') {
        panel.toolPanelParams = {
          gridName: this.gridName,
          gridConfig: this.gridConfig,
        };
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.gridData = changes['gridData'].currentValue;
    if (this.gridData?.data || this.gridData) {
      this.populateRowData(this.params);
    }
  }

  onGridNext() {
    this.guidedTourGridEvent.emit();
  }

  onGridPrev() {
    this.guidedTourGridPrevEvent.emit();
  }

  async populateRowData(params: GridReadyEvent) {
    const data = this.gridData?.data || this.gridData;
    this.rowData = data;
    this.gridApi?.hideOverlay();
  }

  // Example load data from sever
  onGridReady(params: GridReadyEvent) {
    this.params = params;
    this.gridApi = params.api;
    this.populateRowData(params);
    if (this.isCheckOrganization) {
      setTimeout(() => {
        this.gridApi.forEachNode((node: any) => {
          if (node.data && node.data?.id) {
            const rowIndex = node.rowIndex;
            if (rowIndex !== undefined) {
              const columnElements = document.querySelectorAll(
                `[row-index="${rowIndex}"] .ag-cell`
              );
              columnElements.forEach(element => {
                element.classList.add('organizationDataMap');
              });
            }
          }
        });
      }, 1000);
    }
  }

  onGridFilterTriggered(data: any) {
    if (this.quickFilterTimeout) {
      clearTimeout(this.quickFilterTimeout);
    }
    this.quickFilterTimeout = delayedFunctionCall(this.debounceQuickFilter, 300, this, data);
  }

  async debounceQuickFilter(data: any) {
    if (this.isServerSide) {
      this.onPaginationChanged();
    } else {
      if (this.isClientSide) {
        this.gridApi?.setQuickFilter(data?.target?.value);
        this.gridService.onPaginationChanged(this.gridApi, 1, this.pageSize, this.gridName);
      } else if (data?.target?.value) {
        const filteredData = this.rowData.filter((el: any) => {
          return this.columnDefs.some((column: any) => {
            return el[column.field]
              ?.toString()
              ?.toLowerCase()
              .includes(data?.target?.value.toLowerCase());
          });
        });
      }
    }
    await this.setLayuOutAfterFilter();
  }

  setLayuOutAfterFilter() {
    if (this.gridApi?.getDisplayedRowCount() <= 0) {
      this.gridApi?.showNoRowsOverlay();
    } else {
      this.gridApi?.hideOverlay();
    }
  }

  async onPageSizeChanged(newValue: any, currentPage: number | null) {
    if (this.isServerSide) {
      this.pageSize = Number(newValue);
      this.pageNo = currentPage;
      this.gridApi.paginationSetPageSize(Number(newValue));
      const data = {
        pageSize: Number(newValue),
        goToPage: currentPage,
      };
      this.paginationChangeEvent.emit(data);
    } else {
      this.pageSize = Number(newValue);
      // this.isClientSide = this.gridData?.length == Number(newValue) ? false : true;
      this.isClientSide = true;
      delayedFunctionCall(this.changePageSizeForAll, 0, this, newValue);
    }
  }

  changePageSizeForAll(newValue: any) {
    this.gridApi?.paginationSetPageSize(Number(newValue));
  }

  onPageNumberClicked(pageNumber: any, gridName: any, pageSize: number) {
    this.pageNo = pageNumber;
    this.pageSize = pageSize;
    const data = {
      pageSize: pageSize ?? 10,
      goToPage: pageNumber,
    };
    this.gridApi?.deselectAll();
    if (this.isServerSide) {
      this.paginationChangeEvent.emit(data);
    } else {
      this.gridApi?.paginationGoToPage(pageNumber - 1);
      this.pageNo = pageNumber;
      this.gridService.onPaginationChanged(this.gridApi, this.pageNo, this.pageSize, gridName);
    }
  }

  onPaginationChanged() {
    this.pageNo = this.supressPagination || this.pageSize > 100 ? 1 : this.pageNo;
    this.gridApi?.deselectAll();
    this.gridApi?.paginationSetPageSize(Number(this.pageSize));
    this.gridService.onPaginationChanged(
      this.gridApi,
      this.pageNo ?? 1,
      this.pageSize,
      this.gridName
    );
  }

  onSortChanged(event: any) {
    const sortstate = event.columnApi.getColumnState().find((s: any) => s.sort != null);
    if (sortstate) {
      const sortColumnState = {
        columnName: sortstate.colId,
        dir: sortstate.sort,
      };
      this.sortChangeEvent.emit(sortColumnState);
    }
    this.gridApi?.deselectAll();
  }

  onEditButtonClick(params: any) {
    this.gridApi.startEditingCell({
      rowIndex: params.rowIndex,
    });

    this.editDataEvent.emit();
    this.gridApi?.deselectAll();
  }

  async openPackagingContentModal(id: any, isEdit: boolean) {
    const itemId = isEdit ? id?.id : 0;
    const response = (await this.projectsService.openPackagingContentConfigModal(itemId)).data;
    this.modal.invoke('packagingContentConfig', {
      initialState: {
        packagingContentData: response,
      },
      class: 'pallet-view-modal',
    });
  }

  addRecord(type: any, range: any, id?: any, isEdit?: any) {
    const obj = {
      id: 1,
      index: 0,
      processName: 'Select process',
      amount: 0,
      cost: 0,
      packageCost: 0,
      process: 0,
      energyName: 'Select process',
    };
    const objForStorage = {
      id: 0,
      index: 0,
      energyName: 'Select process',
      amount: 0,
      cost: 0,
      packageCost: 0,
      energyProcessId: 0,
    };
    const objForReuse = {
      id: 0,
      index: 0,
      amount: 0,
      cost: 0,
      packageCost: 0,
      energyProcessName: 'Select process',
      energyProcessId: 0,
    };
    const objForMaterialIngrediant = {
      id: 1,
      index: 0,
      endofLifeIdentifierId: null,
      endofLifeIdentifierName: '',
      materialTypeId: 0,
      weight: 0,
      recycledContent: 0,
      scrapedWeight: 0,
      factorValue: null,
      materialName: 'Select material',
    };
    const objForMaterialProcess = {
      id: 0,
      index: 0,
      processName: 'Select material process',
      amount: 0,
      cost: 0,
      packageCost: 0,
      process: 0,
    };
    const myNewAddProject = { id: 0, index: 0, range: range, recycledCreditId: isEdit };
    const objForOrgReporting = {
      id: 0,
      index: 0,
      numberofUnitsByYear: 0,
      year: 'Select a year',
      productGroup: 0,
      productGroupName: 'Select a product',
      packageCost: 0,
      isChecked: false,
      yearId: 0,
      productGroupId: 0,
    };
    const objForAddSKU = { index: 0, numberOfUnitsProduced: 0, year: 'Select a year' };
    const objForAddProductMix = {
      index: 0,
      name: 'Select a product',
      description: '',
      id: 0,
      ratio: 0,
      productId: 0,
    };
    switch (type) {
      case 'customConversion':
        this.customFacade.addConversionProcessActions(obj, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'process',
          });
        }, 0);
        break;
      case 'customFilling':
        this.customFacade.addfillingIngredientAction(obj, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'process',
          });
        }, 0);
        break;
      case 'customStorage':
        this.customFacade.addStorageProcessActions(objForStorage, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'EnergyName',
          });
        }, 0);
        break;
      case 'customReuse':
        this.customFacade.addReuseIngredientAction(objForReuse, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'process',
          });
        }, 0);
        break;
      case 'customMaterialIngredient':
        this.customFacade.addMaterialIngredientActions(objForMaterialIngrediant, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'material',
          });
        }, 0);
        break;
      case 'customMaterialProcess':
        this.customFacade.addMaterialProcessActions(objForMaterialProcess, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'process',
          });
        }, 0);
        break;
      case 'myNewAddProject':
        this.projectFacade.newMyProjectAction(myNewAddProject, 'add');
        break;
      case 'orgReportingProcess':
        this.projectFacade.newMyProjectOrgReporting(objForOrgReporting, 'add');
        break;
      case 'packagingContentConfig':
        this.openPackagingContentModal(0, isEdit);
        break;
      case 'skuYearProcess':
        this.myOrganizationFacade.addSKUProcessActions(objForAddSKU, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'Year',
          });
        }, 0);
        break;
      case 'productLossGrid':
        this.projectFacade.updateProductMixAction(objForAddProductMix, 'add');
        setTimeout(() => {
          this.params.api.startEditingCell({
            rowIndex: 0,
            colKey: 'Name',
          });
        }, 0);
        break;
      default:
        break;
    }
  }

  onCellFocused(event: any) {
    if (this.gridName.toLowerCase() == 'litter impact') {
      // Call the refresh function of the custom cell renderer when the cell is focused
      const cellRenderer = event.api.getCellRendererInstances({ columns: [event.column] })[
        event.rowIndex
      ];
      if (cellRenderer) {
        cellRenderer.refresh(event);
      }
    }
  }

  rowDragged(event: any) {
    const movingNode = event.node;
    const overIndex = event.overIndex!;
    const gridData: any = [];
    this.gridApi.forEachNode((node: any) => {
      gridData.push(node.data);
    });

    const movingData = gridData.splice(movingNode.rowIndex!, 1)[0];
    gridData.splice(overIndex, 0, movingData);
    this.changeRowOrder.emit(gridData);
  }
  ngOnDestroy(): void {
    this.gridApi?.destroy();
  }
}

function createServerSideDatasource(server: any): IServerSideDatasource {
  return {
    getRows: params => {
      // get data for request from our fake server
      const response = server.getData(params.request);
      // simulating real server call with a 500ms delay
      setTimeout(() => {
        if (response.success) {
          // supply rows for requested block to grid
          params.success({ rowData: response.rows });
          if (!response.rows?.length) {
            params.api.showNoRowsOverlay();
          } else {
            params.api.hideOverlay();
          }
        } else {
          params.fail();
        }
      }, 500);
    },
  };
}
